<!-- <dac-client-dialog [isOpen]="openTermsAndConditions" (close)="openTermsAndConditions = false"></dac-client-dialog> -->
<div class="form-group">
  <label for="token">Login Token</label>
  <input class="form-control" type="text" id="token" name="token" [(ngModel)]="token" (keypress)="handleSubmit($event)" />
</div>
<div class="form-group">
  <input class="btn btn-primary" type="submit" value="Continue" (click)="login()" />
</div>
<div class="form-group">
  <p class="alert alert-info">Provide the unique code that your therapist has given you to login.  Contact your therapist if you have not received a login token.</p>
</div>
<p class="small">By clicking Continue, you agree to our <a target="_blank" [routerLink]="['/terms-and-conditions']">Terms of Service</a>, and <a target="_blank" [routerLink]="['/privacy']">Privacy Policy.</a></p>


// WEBPACK FOOTER //
// ./src/app/login/login/login.component.html